import { Tooltip as MuiTooltip } from '@mui/material';

const Tooltip = ({ message, children }) => {
    return (
        <MuiTooltip title={message} arrow componentsProps={{
            tooltip: { className: " text-lg bg-secondary" },
        }}>
            {children}
        </MuiTooltip>

    );
};

export default Tooltip;